import { inject } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import * as actions from '../actions/filter-fields.action';
import { switchMap, map, catchError } from 'rxjs/operators';
import { EventService } from '../../services';

export const LoadFilterFields$ = createEffect(
  (actions$ = inject(Actions), service = inject(EventService)) => {
    return actions$.pipe(
      ofType(actions.LoadFilterFields),
      switchMap(() =>
        service.getFilterFields().pipe(
          map(fields => actions.LoadFilterFieldsSuccess({ fields })),
          catchError(error => of(actions.LoadFilterFieldsFail({ error })))
        )
      )
    );
  },
  { functional: true }
);
